"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _ListItem = _interopRequireDefault(require("../List/ListItem"));
var _ListItemText = _interopRequireDefault(require("../List/ListItemText"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tokens = require("../styles/tokens");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _excluded = ["classes", "children", "disabled", "searchString", "divider", "onClick", "isActive", "LeftIconComponent", "RightIconComponent", "scrollFocus", "isSubheader"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  return {
    item: {
      outline: 'none',
      cursor: 'pointer',
      borderColor: theme.palette.grey['300'],
      '&:active': {
        '& mark': {
          color: 'white'
        }
      }
    },
    mark: {
      color: _tokens.colorTextNeutral500,
      backgroundColor: 'initial'
    },
    icons: {
      '& svg': {
        flexShrink: 0,
        fill: theme.palette.grey['500']
      }
    },
    paddingRightWithIcon: {
      paddingRight: _tokens.spacing40
    },
    paddingLeftWithIcon: {
      paddingLeft: _tokens.spacing40
    },
    subheader: {
      color: _tokens.colorTextNeutral500
    },
    subheaderHover: {
      pointerEvents: 'none',
      '&:not(:first-child)': {
        marginTop: _tokens.spacing40
      }
    }
  };
};

// Refer following link for more details about escaping regex characters
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
var escapeRegExp = function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
var SearchItem = function SearchItem(props) {
  var _classNames, _classNames2;
  var classes = props.classes,
    childrenProp = props.children,
    disabled = props.disabled,
    searchString = props.searchString,
    divider = props.divider,
    onClick = props.onClick,
    isActive = props.isActive,
    LeftIconComponent = props.LeftIconComponent,
    RightIconComponent = props.RightIconComponent,
    scrollFocus = props.scrollFocus,
    isSubheader = props.isSubheader,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var children = childrenProp;
  var label = children;
  var itemRef = /*#__PURE__*/_react.default.createRef();

  // disabling warning for missing dpendency of itemRef
  // refer to the following link for more details on why this is the best option for this case
  // https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
  (0, _react.useEffect)(function () {
    if (isActive) {
      itemRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  // Copied from https://codepen.io/rebosante/pen/eENYBv
  (0, _react.useEffect)(function () {
    if (scrollFocus) {
      var listItem = itemRef.current;
      var topPos = listItem.offsetTop;
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };
      var scrollTo = function scrollTo(element, to, duration) {
        var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
        var _animateScroll = function animateScroll() {
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if (currentTime < duration) {
            setTimeout(_animateScroll, increment);
          }
        };
        _animateScroll();
      };

      //Added timeout to avoid unusual scroll when show next button hides for the last set of records. 
      setTimeout(function () {
        scrollTo(listItem.parentNode, topPos, 600);
      });
    }
    // itemRef dependency causing issue while navigating from keyboard hence not added in the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollFocus]);
  if (children && searchString) {
    var regex = new RegExp(escapeRegExp(searchString), 'gi');
    children = children.replace(regex, function (val) {
      return "<mark class=" + classes.mark + ">" + val + "</mark>";
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.item, classes.icons, props.className),
    classes: {
      root: (0, _classnames.default)((_classNames = {}, _classNames[classes.subheaderHover] = isSubheader, _classNames))
    },
    disabled: disabled,
    "aria-disabled": disabled ? true : false,
    "aria-label": label,
    "aria-selected": isActive,
    divider: divider,
    ref: itemRef,
    onClick: disabled ? null : onClick
  }, rest, {
    tabIndex: 0,
    button: true,
    role: "option",
    "aria-hidden": isSubheader ? true : undefined
  }), LeftIconComponent, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    classes: {
      root: (0, _classnames.default)((_classNames2 = {}, _classNames2[classes.paddingLeftWithIcon] = !(0, _isNil.default)(LeftIconComponent), _classNames2[classes.paddingRightWithIcon] = !(0, _isNil.default)(RightIconComponent), _classNames2[classes.subheader] = isSubheader, _classNames2))
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  })), RightIconComponent));
};
SearchItem.displayName = 'SearchItem';
SearchItem.propTypes = {
  /**
   * The text of the item.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * If `true`, the item will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,
  /**
   * Value of this prop would be returned when user clicks on list item.
   */
  option: _propTypes.default.object,
  /**
   * @ignore
   */
  scrollFocus: _propTypes.default.bool,
  /**
   * 
   * Changes style of ListItemText to make it look like a subheader.
   */
  isSubheader: _propTypes.default.bool,
  /**
   * @ignore
   *
   * Icon to be displayed to the left of the text
   */
  LeftIconComponent: _propTypes.default.node,
  /**
   * @ignore
   *
   * Icon to be displayed to the right of the text
   */
  RightIconComponent: _propTypes.default.node,
  /**
   * @ignore
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  searchString: _propTypes.default.string,
  /**
   * @ignore
   */
  onClick: _propTypes.default.func,
  /**
   * @ignore
   */
  isActive: _propTypes.default.bool,
  /**
   * @ignore
   */
  className: _propTypes.default.string
};
SearchItem.defaultProps = {
  isSubheader: false
};
var _default = exports.default = (0, _styles.default)(styles, {
  name: 'SearchItem'
})(SearchItem);